import React, { useState } from "react";
import CustomINput from "../../components/common/InputField/InputField";
import CustomDropDown from "../../components/common/dropdown/Dropdown";
import IconArrow from "../../assets/icons/Vector (1).svg";
import arrowleft from "../../assets/icons/arrow-left.svg";
import brif2 from "../../assets/icons/briefcase-2-line.svg";
import first from "../../assets/icons/first-aid-kit.svg";
import "./PhysicianForm.css";
import Badges from "../../components/common/badges/Badges";
import apiService from "../../services/apiService";
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined";

const Professional = ({
  values,
  handleChange,
  handleBlur,
  errors,
  touched,
  handleClick,
  selectedTab,
  setFieldTouched,
  setTouched,
  setFieldValue,
  validateForm,
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [sites, setSites] = React.useState([]);
  const [selectedBadges, setSelectedBadges] = React.useState([]);

  const [medSp, setMedSp] = React.useState([]);

  const getSites = async () => {
    try {
      const { data } = await apiService.get("/site");
      setSites(
        data.map(({ name, _id, ...rest }) => ({
          label: name,
          value: _id,
          ...rest,
        }))
      );
    } catch (error) {
      console.error("Error fetching sites:", error);
    }
  };

  const med = async () => {
    const url = "/moh_manager/all/medSpecialties";
    try {
      const response = await apiService.get(url, values);

      setMedSp(response.data);
    } catch (error) { }
  };

  const init = () => {
    med();
    getSites();
  };
  React.useEffect(() => {
    init();
  }, []);

  return (
    <div>
      <div
        className=" text-medium text-gray-500   rounded-lg w-full"
        id="profile"
        role="tabpanel"
        aria-labelledby="profile-tab"
      >
        <div className="flex items-center space-x-1 mb-4">
          <div className="pl-4">
            <img src={brif2} alt="License Icon" className="w-6 h-6 " />
          </div>
          <h3 className="label-medium pt-1">Job Information</h3>
        </div>
        <div className="border-t border-l">
          <div className=" pt-1 ml-4 ">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
              <div>
                <CustomINput
                  label="Current Job Organization"
                  className="border border-gray-300 text-gray-800 bg-white focus:bg-transparent focus:outline-none px-4 py-3.5 rounded-[12px]"
                  width=" w-full"
                  height="h-[40px]"
                  labelClass={`label-small`}
                  isRequired={true}
                  isRequiredClass="text-[#2D9F75]"
                  name="currentJobOrganization"
                  value={values.currentJobOrganization}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                {errors.currentJobOrganization &&
                  touched.currentJobOrganization && (
                    <div className="text-red-500 text-[12px]">
                      {errors.currentJobOrganization}
                    </div>
                  )}
              </div>
              <div>
                <CustomINput
                  label="Current Job Title"
                  className="border border-gray-300 text-gray-800 bg-white focus:bg-transparent focus:outline-none px-4 py-3.5 rounded-[12px]"
                  isRequired={true}
                  width="w-full"
                  height="h-[40px]"
                  labelClass={`label-small`}
                  isRequiredClass="text-[#2D9F75]"
                  name="currentJobTitle"
                  value={values.currentJobTitle}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                {errors.currentJobTitle && touched.currentJobTitle && (
                  <div className="text-red-500 text-[12px]">
                    {errors.currentJobTitle}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="pt-6 ml-4">
            <div className="flex items-center space-x-1 mb-4">
              <div className="">
                <img src={first} alt="License Icon" className="w-6 h-6 " />
              </div>
              <h3 className=" label-medium pt-1">Medical Specialties</h3>
            </div>
            <hr />
            <div className="pt-1 mt-4">
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
                {/*     <SearchBar
                                    label="Practitioner Type 3"
                                    className="border border-gray-300 text-gray-800 bg-white focus:bg-transparent focus:outline-none px-4 py-3.5 rounded-[11px]"

                                    height='h-[40px]'
                                    labelClass={`label-small`}
                                    isRequired={true}
                                    isRequiredClass="text-[#2D9F75]"
                                    badgeLabels={badgeLabels}
                                    searchQuery={searchQuery}
                                    setSearchQuery={setSearchQuery}

                                />*/}
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-1 gap-4">
                <div className="pt-6">
                  <Badges
                    badgeLabels={medSp}
                    setSelectedBadges={setSelectedBadges}
                    selectedBadges={selectedBadges}
                    name="medicalSpecialties"
                    value={
                      values.medicalSpecialties ||
                      values?.related_medical_specialties
                    }
                    // onChange={(e) => {
                    //     handleChange(e)
                    //     setFieldValue('medicalSpecialties', e.target.value);
                    // }
                    // }
                    // onBlur={handleBlur}
                    onChange={(e) => {
                      handleChange(e);
                      setFieldValue("medicalSpecialties", e.target.value);
                    }}
                    onBlur={() => {
                      setFieldTouched("medicalSpecialties", true);
                    }}
                  />

                  {touched.medicalSpecialties && errors.medicalSpecialties && (
                    <div className="text-red-500 text-[12px]">
                      {errors.medicalSpecialties}
                    </div>
                  )}
                </div>
              </div>

              <div className="pt-6 ml-4">
                <div className="flex items-center space-x-1 mb-4">
                  <div className="flex items-center justify-center">
                    <ApartmentOutlinedIcon
                      className="w-6 h-6"
                      sx={{ color: "#2D9F75" }}
                    />
                  </div>
                  <h3 className=" label-medium pt-1">Hospital Preference</h3>
                </div>
                <hr />
                <div className="pt-1 mt-2">
                  <CustomDropDown
                    label="Prefered Hospital"
                    className="border border-gray-300 text-gray-800 bg-white focus:bg-transparent focus:outline-none rounded-[11px]"
                    options={sites}
                    height="h-[40px]"
                    labelClass={`label-small`}
                    isRequired={true}
                    isRequiredClass="text-[#2D9F75]"
                    name="siteIds"
                    value={values.siteIds}
                    search={true}
                    isMulti={true}
                    onFieldSelect={async (e) => {

                      await new Promise(resolve => setTimeout(resolve, 2000));
                      console.log("eeeeeee", e)
                      setFieldValue("siteIds", e
                      );
                    }}
                    onBlur={handleBlur}
                  />
                  {errors.siteIds && touched.siteIds && (
                    <div className="text-red-500 text-[12px]">
                      {errors.siteIds}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="flex justify-end items-center pt-25"
          style={{ paddingTop: "15px" }}
        >
          <div className="flex items-center justify-between w-[300px]">
            <button
              type="button"
              onClick={() => handleClick(2)}
              class="w-[128px] h-[40px] text-[#007A63] flex justify-center items-center  border border-[#007A63]  focus:ring-4 focus:outline-none  font-medium rounded-lg text-sm  text-center  [#007A63] [#007A63] :text-white"
            >
              <img
                src={arrowleft}
                alt="logo"
                style={{ paddingRight: "12px" }}
              />
              Previous
            </button>
            <button
              type="button"
              onClick={() =>
                handleClick(4, validateForm, setTouched, setFieldTouched)
              }
              className="text-white bg-[#007A63] flex justify-center items-center  focus:ring-4 focus:outline-none w-[128px] h-[40px] font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center"
            >
              Next
              <img src={IconArrow} alt="logo" style={{ paddingLeft: "12px" }} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Professional;
